import type { ProductListingResource, ComparatorProductVariantResource, OrderItemWithStock, ProductVariantResource } from '@storefront/resources';

export function addToWishlistEvent(item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource, currency: string) {
  return {
    'event': 'add_to_wishlist',
    'ecommerce': {
      'currency': currency,
      'value': calculateItemTotalPrice(item),
      'items': [
        {
          item_name: getItemName(item),
          item_id: getItemId(item),
          price: Number(Number(item.priceGross).toFixed(2)),
          quantity: 1,
          ...(getItemType(item) !== 'FLEXIBLE' && {
            discount: calculateItemDiscount(item),
          }),
        },
      ],
    },
  };
}

function calculateItemTotalPrice(item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource): number {
  const stock = 1;

  return Number((Number(item.priceGross) * stock).toFixed(2));
}

function getItemType(
  item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource,
): string | null {
  if ('type' in item) {
    // ProductListingResource/ComparatorProductVariantResource/ProductVariantResource
    return item.type;
  }

  // OrderItemWithStock
  return item.productType;
}

function getItemName(
  item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource,
): string | null {
  if ('title' in item) {
    // ProductListingResource/ComparatorProductVariantResource/ProductVariantResource
    return item.title;
  }

  // OrderItemWithStock
  return item.variantTitle;
}


function getItemId(
  item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource,
): number {
  if ('productId' in item) {
    return item.productId;
  }

  // OrderItemWithStock
  return item.id;
}

function calculateItemDiscount(item: ProductListingResource | ComparatorProductVariantResource | OrderItemWithStock | ProductVariantResource): number {
  if (item.regularGross === null) {
    return 0;
  }

  const regularGross = Number(item.regularGross);
  const priceGross = Number(item.priceGross);

  return Number((regularGross - priceGross).toFixed(2));
}